<template>
  <div class="page light intro">
    <div class="inner">
      <h1>Keeping your costs down</h1>

      <h2>Rehearse your material</h2>
      Rehearse your material before you arrive, this will save valuable time!
      <h2>Change your strings / reeds / etc</h2>
      If you play a string instrument put on a new set of strings before you arrive and bring spares! <br />
      If you play a reed instrument, it might be an idea to bring a spare reed or two.
      <h2>Ensure all instruments and devices are working correctly</h2>
      If you use electronic devices such as guitar pedals, make sure they are working correctly and they have new batteries before you bring them to the studio! It's always a good idea to bring spare batteries!
      <br />
      <p>
      Generally just try to avoid anything that can hold you up in the studio so that you are making good use of the hours you are paying for without having to rush your project.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatesIntro'
}
</script>

<style scoped lang="scss">
.intro{
  padding-top:80px;
  .inner{
    max-width: 1200px;
    margin:0 auto;
    padding:0 5%;

  }
}
.offers{
  display:flex;
  justify-content: center;
  padding:100px 0;
  // align-content: center;
}
.offer{
  background: rgba(176, 176, 176, 0.667);
  border-radius:10px;
  color: black;
  margin:1em;
  padding:1.5em;
  text-align: center;
  font-size: large;
}
.cost{
  font-size: xx-large;
}
h1{
  margin-bottom:0.6em;
}
@media only screen and (max-width: 800px) {
  .offers{
    display: block;
  }
}
</style>
